import { Pipe, PipeTransform } from '@angular/core';
import { LogService } from '@app/core';

@Pipe({
  name: 'objectToString'
})
export class ObjectToStringPipe implements PipeTransform {
  transform(obj: any, arg1?: string, arg2?: string): any {
    let response: string = '';
    obj.forEach(function (item, index) {
      response += (arg2 && arg2.length > 0) ? item[arg1] + ' ' + item[arg2] : item[arg1];
      if (obj.length - 1 > index)
        response += ' , ';
    });
    return response;
  }
}
